// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PyidK32q7PfDc9 {\n  margin-bottom: 68px;\n  min-height: 285px;\n  position: relative;\n}\n.JVUCIF8xoUEPpv {\n  bottom: -68px;\n  left: 0;\n  margin: 19px auto;\n  position: absolute;\n  right: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationsList": "PyidK32q7PfDc9",
	"spinner": "JVUCIF8xoUEPpv"
};
export default ___CSS_LOADER_EXPORT___;
